import { useAggregatedDataV2 } from "~/hooks/useAggregatedDataV2.ts";
import userViewGuard from "~/hooks/useViewPermssionsCheck";
import { useAllClients } from "~/modules/client/api/client/clientQueries";
import { useAllCompanies } from "~/modules/client/api/company/companyQueries.ts";
import ClientsIndexView from "~/modules/client/components/ClientsIndexView.tsx";
import { useAllCompanyAvatarImages } from "~/modules/image/api/avatarImage/avatarImageQueries.ts";
import { useAllProjects } from "~/modules/project/api/project/projectQueries.ts";
import LoadingPage from "~/pages/LoadingPage";
import { PermissionNames } from "~/types/entityNames.ts";

const ClientsIndexPage: React.FC = () => {
	const guard = userViewGuard(PermissionNames.CanManageProjects);
	if (guard) return guard;

	const { data, options } = useAggregatedDataV2({
		allCompanyAvatarImages: useAllCompanyAvatarImages(),
		companies: useAllCompanies(),
		projects: useAllProjects(),
		clients: useAllClients(),
	});

	if (options.loadingPercent < 100) return <LoadingPage pcent={options.loadingPercent} />;
	return <ClientsIndexView {...data} />;
};

export default ClientsIndexPage;
